module.exports = __webpack_public_path__ + "img/red2.bef01d38.png";